var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"booking-divider booking-divider-right"},[_c('div',{staticClass:"booking-content"},[_c('display-banner'),_c('div',{staticClass:"font-size-h2 text-header-color px-4 my-5 text-center"},[_vm._v("BOOKING PORTAL FOR NEW CLIENTS IS CURRENTLY NOT AVAILABLE.")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }